import { RICOS_NODE_TYPE_TO_DATA_FIELD } from "../consts.js";
const isType = (type) => (node) => node.type === type;
const getDataFieldName = ({ type }) => RICOS_NODE_TYPE_TO_DATA_FIELD[type];
const getDataFieldValue = (node) => {
  const dataFieldName = getDataFieldName(node);
  return dataFieldName && dataFieldName in node ? node[dataFieldName] : void 0;
};
export {
  getDataFieldName,
  getDataFieldValue,
  isType
};
//# sourceMappingURL=utils.js.map
